import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React from 'react';
import RowWithImageSkeleton from '@/components/molecules/DesktopTable/partials/DesktopTableSkeleton/partials/RowWithImageSkeleton';
const MobileCryptoSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full justify-center rounded-lg bg-gray-200 py-3.5"><div className="h-6 w-28 rounded-xs bg-gray-300" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full animate-pulse flex-col gap-4 lg:hidden" data-sentry-component="MobileCryptoSkeleton" data-sentry-source-file="index.tsx">{t0}<div className="flex w-full flex-col justify-center rounded-lg bg-gray-200 px-6">{[...Array(6)].map(_temp)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MobileCryptoSkeleton;
function _temp(_, i) {
  return <div key={i} className="border-b border-b-gray-100 py-4"><RowWithImageSkeleton seed={i} /></div>;
}